import { Logger } from 'Common/appshell_types/loggerTypes';
import { AbstractAppBridge, NotificationType, WindowType } from 'Common/appshell_types/appBridgeTypes';

declare const window: WindowType;

export default class AppBridge implements AbstractAppBridge {
    public static instance: AppBridge;

    private readonly logger: Logger;

    private constructor(logger: Logger) {
        this.logger = logger;
    }

    public static getInstance(logger: Logger): AppBridge {
        if (!this.instance) {
            this.instance = new this(logger);
        }

        return this.instance;
    }

    public sendTrackingData(data: any): void {
        let message = data;
        if (window.AndroidAppBridge) {
            const isKnownEvent = !!data?.event;

            message = isKnownEvent
                ? {
                      ...data,
                      event_category: data.category,
                      event_action: data.action,
                      event_label: data.label,
                  }
                : data;
        }

        this.postMessage('updateDataLayer', message);
    }

    public sendShowCheckoutEvent(url: string): void {
        this.postMessage('showCheckout', url);
    }

    public sendShowCDPEvent(url: string): void {
        this.postMessage('showCDP', url);
    }

    public sendShowOverlay(url: string): void {
        this.postMessage('showOverlay', url);
    }

    public sendShowProductEvent(sku: string): void {
        this.postMessage('showProduct', sku);
    }

    public sendShowLoginEvent(data: any): void {
        this.postMessage('showLogin', data);
    }

    public sendNotification(data: NotificationType): void {
        const { type, message } = data;
        this.postMessage('displayMessage', { type, text: message });
    }

    public postMessage(action: string, message: any): void {
        try {
            if (window.AndroidAppBridge) {
                const payload = JSON.stringify({
                    action,
                    message,
                });

                window.AndroidAppBridge.postMessage(payload);
            } else if (window.webkit) {
                window.webkit.messageHandlers.appBridge.postMessage({ action, message });
            } else {
                throw new Error('No tracker is found for webview');
            }
        } catch (e) {
            this.logger.error('AppBridge - event triggering error', { error: e });
        }
    }
}
